import { useState } from "react";
import { UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const PersonForm = ({ onSubmit, prefix }) => {
  const [form, setForm] = useState({ last_name: "", first_name: "", email: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (await onSubmit(form)) setForm({ last_name: "", first_name: "", email: "" });
  };

  return (
    <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1.4fr_auto] gap-2" data-testid={`${prefix}-person-form`}>
      <Input placeholder="Nom" value={form.last_name} onChange={set("last_name")} required data-testid={`${prefix}-last-name`} />
      <Input placeholder="Prénom" value={form.first_name} onChange={set("first_name")} required data-testid={`${prefix}-first-name`} />
      <Input type="email" placeholder="Adresse email" value={form.email} onChange={set("email")} required data-testid={`${prefix}-email`} />
      <Button type="submit" className="bg-pink-600 hover:bg-pink-700" data-testid={`${prefix}-add-btn`}><UserPlus className="w-4 h-4 mr-1" />Ajouter</Button>
    </form>
  );
};
